import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Search } from '../../../../resources/images/svg/search.svg';
import { ReactComponent as Ticket } from '../../../../resources/images/svg/ticket.svg';
import { ReactComponent as Calendar } from '../../../../resources/images/svg/calendar.svg';
import { useAuth } from '../../../contexts/userContext/userContext';
import { useModal } from '../../../contexts/modalsContext/modalsContext';

function MobileNavigation() {
  const { lang } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { mobileNavigationAction, setMobileNavigationAction, user } = useAuth();
  const { setShowAuthModal } = useModal();

  const handleNavigation = (e) => {
    switch (e) {
      case 'schedule':
        navigate(`/${lang}/schedule`);
        break;
      case 'tickets':
        if (user?.id) {
          navigate(`/${lang}/profile?tab=purchased-tickets`);
        } else {
          setShowAuthModal(true);
        }
        break;
      default:
        setMobileNavigationAction(e);
    }
  };

  const navigationItems = [
    {
      name: 'schedule',
      Icon: Calendar,
    }, {
      name: 'search',
      Icon: Search,
      iconClassNames: '-rotate-45',
    }, {
      name: 'tickets',
      Icon: Ticket,
    },
  ];

  useEffect(() => {
    if (location.pathname === `/${lang}` && !mobileNavigationAction) {
      setMobileNavigationAction('search');
    }
  }, [mobileNavigationAction]);

  const isHomePage = location.pathname === '/ka' || location.pathname === '/en' || location.pathname === '/am';

  return (
    <menu className={`${isHomePage ? 'flex' : 'hidden'} lg:hidden justify-between p-5 w-full m-0 list-none mobile-navigation z-10`}>
      {
        navigationItems.map((item) => (
          <li key={item.name} className={`flex-1 flex justify-center items-center ${item.name === mobileNavigationAction && 'active'}`}>
            <item.Icon
              onClick={() => handleNavigation(item.name)}
              className={item?.iconClassNames}
            />
          </li>
        ))
      }
    </menu>
  );
}

export default MobileNavigation;
